import { FireShutterT } from "tnbimbase";
import { EXTRA_CTRL_TYPE } from "@/commons/enums/extra-control-code";
import { EXTRA_SINGAL } from "@/commons/enums/extra-singal";
import { AddPrimitivesCommand, BasicControl, CURSOR_TYPE, Circle, Cylinder, CylinderT, DYMODE_MODE, ExtrudeSolidT, Line, Listeners, MOUSE, Plane, Point, Polygon, SelectionBox, TnEngineContext, TnEngineExtraContext, ViewEditor, dymode } from "pytha";
import { Vector3 } from "three";

/**
 * 布置防火卷帘的二级控制器
 */
export class AssembleFireShutterControl extends BasicControl {
    id = EXTRA_CTRL_TYPE.ASSEMBLE_FIRE_SHUTTER;

    needInit: boolean;

    layerUuid: string;
    // 防火卷帘临时图元
    helpFireShutter: FireShutterT;

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    point_down: Point = new Point();
    point_move: Point = new Point();

    capturePoint: Vector3;

    initFireShutterData: any


    private _pickBox: SelectionBox
    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        this.needInit = true;

        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();

        this.editor = editor;
        this.listeners = listeners;

        this.listeners.getSignal(EXTRA_SINGAL.onAssembleFireShutter).add(this.onAssembleFireShutter);
        this._pickBox = new SelectionBox(editor.camera);
        // 钝化夹点
        this.editor.clampControl.enabled = false;

        console.log('AssembleFireShutterControl added')
    }

    dispose(): void {
        this.listeners.getSignal(EXTRA_SINGAL.onAssembleFireShutter).remove(this.onAssembleFireShutter);
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
        this.listeners.signals.noNeedCapture.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;

        this.editor.clampControl.enabled = true;
        this.editor.clampControl.hidden = false;
        this.listeners.signals.onOnePickOnly.dispatch(false);
        if (this.helpFireShutter && this.helpFireShutter.viewObj && this.helpFireShutter.viewObj.parent) {
            this.helpFireShutter.viewObj.parent?.remove(this.helpFireShutter.viewObj);
        }

        console.log('AssembleFireShutterControl removed')
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    initControl(data: any): void {
        this.onAssembleFireShutter(data)
    }

    generateFireShutter = () => {
        let width = this.initFireShutterData?.width
        let radius = this.initFireShutterData?.radius
        let height = this.initFireShutterData?.height
        let opacity = this.initFireShutterData?.opacity
        // 构造防火卷帘图元，构造一个xoz方向的，基点在卷轴左下
        // 卷轴
        let cylinder = new Cylinder(new Point(0, -radius, radius), radius, width, new Vector3(1, 0, 0));
        let solid = new CylinderT(cylinder);
        // 防火卷帘，厚20mm
        let doorPolygon = new Polygon([], new Vector3(0, -1, 0), new Point(0, 0, 0));
        let doorPoints: Point[] = [
            new Point(0, 0, radius),
            new Point(0, -20, radius),
            new Point(0, -20, -height),
            new Point(0, 0, -height),
        ]
        let curves = [];
        for (let i = 0; i < doorPoints.length; i++) {
            if (i != doorPoints.length - 1) {
                curves.push(new Line(doorPoints[i], doorPoints[i + 1]));
            } else {
                curves.push(new Line(doorPoints[i], doorPoints[0]));
            }
        }
        doorPolygon.set(curves);
        let doorSolid = new ExtrudeSolidT(doorPolygon, new Vector3(1, 0, 0), width);
        this.helpFireShutter = new FireShutterT(new Point(0, 0, 0), [solid, doorSolid], '防火卷帘', new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        this.helpFireShutter.opacity = opacity;
    }

    onAssembleFireShutter = (data: {
        width: number,
        radius: number,
        height: number,
        opacity: number,
        layerUuid: string
    }) => {
        let initData = {
            ...data
        }
        this.listeners.signals.setInitControlData.dispatch(initData);
        this.initFireShutterData = { ...data }

        this.layerUuid = data.layerUuid;
        if (!data?.width
            || !data?.height
            || !data?.radius
            || !data?.opacity
            || !data?.layerUuid) {
            this.extraContext.stmodeContext.pushTip(`缺少防火卷帘组件`);
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return
        }
        // 生成防火卷帘临时图元
        this.generateFireShutter()
        let point = new Vector3(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        let dir = point.clone().normalize();
        let dist = point.length();
        this.helpFireShutter.move(dir, dist);
        this.helpFireShutter.render();
        this.extraContext.sceneContext.scene.add(this.helpFireShutter.viewObj);
        // 派发置空选择集的信号
        this.listeners.signals.emptySelectedEntities.dispatch();
        // 钝化选择
        this.editor.selectControl.setEnabled(false);
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.POINT);
        this.listeners.signals.sendToDymodeTip.dispatch('指定防火卷帘位置:');
        this.extraContext.stmodeContext.setStmode('指定防火卷帘位置');
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
        this.listeners.signals.needCapture.dispatch();
        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        // 订阅确认信号
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        // 监听鼠标移动
        this.editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        // 监听鼠标按下
        this.editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
    }

    _dymodeActive = false;
    onDymodeChanged = (value: dymode) => {
        if (value.mode === DYMODE_MODE.POINT) {
            this.point_down.set(value.x, value.y, value.z);
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        }
    }

    private _foot = new Vector3();
    onKeyMouseConfirm = () => {
        if (!this._dymodeActive) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        } else {
            this.insertFireShutter();
        }
    }

    private _pointLast = new Point();


    private _dir = new Vector3();

    onPointerMove = (event) => {
        if (!!!this.helpFireShutter) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let x = (event.clientX - rect.x) / rect.width * 2 - 1;
        let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
        this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_move);
        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        }
        this._dir.subVectors(this.point_move, this.helpFireShutter.position)
        let length = this._dir.length();
        this._dir.normalize();
        this.helpFireShutter.move(this._dir, length);
        this.helpFireShutter.updateViewGeometry();
        this._pointLast.copy(this.point_move);
        this.listeners.signals.needRender.dispatch();
    }

    onPointerDown = (event) => {
        if (event.button === MOUSE.RIGHT) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        if (event.button !== MOUSE.LEFT) return;
        // 指定了防火卷帘位置
        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let x = (event.clientX - rect.x) / rect.width * 2 - 1;
        let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
        this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_down);
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
        }
        this.insertFireShutter();
    }

    insertFireShutter = () => {
        this._dir.subVectors(this.point_down, this.helpFireShutter.position)
        let length = this._dir.length();
        this._dir.normalize();
        this.helpFireShutter.move(this._dir, length);
        this.helpFireShutter.updateViewGeometry();
        this._pointLast.copy(this.point_move);
        let fireShutter: FireShutterT = this.helpFireShutter.clone();
        fireShutter.layerUuid = this.layerUuid;
        fireShutter.isColorByLayer = true;
        this.editor.history.execute(new AddPrimitivesCommand([fireShutter]));
        this.listeners.signals.onOpeCommandControlEnd.dispatch();
    }
}